import moment from 'moment'
import _ from 'loadsh'
import _co from './const'
import vueCookie from 'vue-cookies';
export default {
    getUser(){
        return localStorage.getItem('xinhuaUser') ? JSON.parse(localStorage.getItem('xinhuaUser')) : null;
    },
    formatPercent(numerator = 0, denominator) {
        if (!denominator) {
            return 100
        }
        return Math.abs(parseInt(numerator / denominator * 100))
    },
    formatPercentStr(cha, sum, periodStr = "昨日", fontBold = true) {
        if (cha) {
            return `，较${periodStr}${cha > 0 ? '增' : '降'}幅<span class="${fontBold ? 'font_b' : ''}">${this.formatPercentAndCeil(cha, sum)}%</span>`
        } else {
            return `，较${periodStr}持平`
        }
    },
    formatPercentAndCeil(numerator, denominator) {
        if (!denominator || !numerator)
            return 0;

        let num = Math.abs(numerator / denominator * 100);
        return Math.ceil(num)
    },
    formatPercentAndCeilStr(numerator, denominator, replaceStr = "。") {
        if (!denominator || !numerator)
            return replaceStr;

        return `，占比${ this.formatPercentAndCeil(numerator, denominator) }%${replaceStr}`
    },
    formatPercentAndTofixed(numerator, denominator, fixedNum= 0) {
        if (!denominator || !numerator)
            return 100;

        let num = Math.abs(numerator / denominator * 100);
        return num.toFixed(fixedNum)
    },
    formatPercentAndTofixed_V2(numerator, denominator, fixedNum= 0) {
        if (!denominator || !numerator)
            return 0;

        let num = Math.abs(numerator / denominator * 100);
        return num.toFixed(fixedNum)
    },
    formatDateStr(periodStr ="日"){
        return periodStr == "日" ? "今日" : `本${periodStr}`;
    },
    // 获取风险占比文案
    getRiskLevelContent(periodStr, entityId, riskLevelCounts, highRiskLevelEvents, entityType = "industry") {
        let dateStr = this.formatDateStr(periodStr);
        let riskLevelStr = `${dateStr}，暂无敏感事件。`
        let riskCount = _.sumBy(riskLevelCounts, 'count'); // 今日风险等级总计
        // let forwardTotal = _.sumBy(riskLevelCounts, 'forwordTotal') || 0;
        if (riskCount) { // 敏感事件 不为 0 时
            // 风险等级最高的
            let levelMax = riskLevelCounts.filter(item => item.count)[0]
            let percent = levelMax.count === riskCount ? 100 : this.formatPercentAndTofixed(levelMax.count, riskCount, 2)
            riskLevelStr = `${dateStr}，${this.convertEntityNameStr(entityId, entityType)}最高风险等级为<b>${this.getRoma(levelMax.level)}级</b>，包含敏感事件<b>${levelMax.count}件</b>，占敏感事件总量的<b>${percent}%</b>。`

            if (highRiskLevelEvents && highRiskLevelEvents.length > 0) {
                riskLevelStr += `其中，传播影响力较大的敏感事件有`
                let arr = [];
                highRiskLevelEvents.forEach(e => {
                    arr.push(`${this.covertHtmlLink(e)}`);
                })
                riskLevelStr += arr.join('、') + '。'
            }
        }
        return riskLevelStr;
    },
    getTimeName(date) {
        let startDate = date === '今日' ? moment().startOf('day').valueOf() :
            date === '近7日' ? moment().subtract(6, 'days').startOf('day').valueOf() :
                date === '本月' ? moment().startOf('month').startOf('day').valueOf() :
                    date === '最近三月' ? moment().subtract(3, 'month').startOf('day').valueOf() :
                        moment(date).startOf('month').valueOf();
        return startDate
    },
    formatStr(date, unit = "MM/DD HH:mm") {
        return date ? moment(date).format(unit) : ""
    },
    getRoma(n) {
        return _co.romaMap[n] || "V";
    },
    getAE(n) {
        return String.fromCharCode(Math.max(n, 1) + 64);
    },
    getCookie(key) {
        let c = document.cookie || '';
        let cookies = c.split(';');
        for (var i = 0; i < cookies.length; i++) {
            let cookie = cookies[i];
            cookie = cookie.replace(/^\s+/, '');
            let cookieArr = cookie.split('=');
            if (cookieArr[0] === key) {
                return cookieArr[1];
            }
        }
        return '';
    },
    removeCookie(name) {
        let date = new Date()
        date.setDate(date.getDate() + -1)
        document.cookie = name + '=' + null + ';expires=' + -1
    },
    getRiskLabelStr(yinbaoRiskArr = [], contentRiskArr, entity = "industry") {
        if (!yinbaoRiskArr.length && !contentRiskArr.length)
            return "";
        let str = "";

        let count1 = yinbaoRiskArr[0] && yinbaoRiskArr[0].count || 0,
            count2 = yinbaoRiskArr[1] && yinbaoRiskArr[1].count || 0;

        if (count1) {
            str = `按照监管重点关注的十大风险分类统计，${entity == "industry" ? "行业" : "企业"}当前面临的核心风险为`;
            str += (count1 && count2) ? `【${yinbaoRiskArr[0].category}】、【${yinbaoRiskArr[1].category}】两类` : `【${yinbaoRiskArr[0].category}】`
        }

        if (contentRiskArr[0].count && contentRiskArr[1].count) {
            str += `；主要内容风险点包括"${contentRiskArr[0].category}、${contentRiskArr[1].category}"`;
        } else if (contentRiskArr[0].count) {
            str += `；主要内容风险点包括"${contentRiskArr[0].category}"`;
        }

        return (_.sumBy(yinbaoRiskArr, "count") || _.sumBy(contentRiskArr, "count")) ? `${str}。` : `${str}`;
    },
    industryRiskContent(data, entity) {//风险概况 文案设置
        let {
                yinbaoRiskCounts,
                riskCategoryCountList,
                total,
            } = data;

        let riskCount = _.sumBy(riskCategoryCountList, 'count');
        let setRiskContent = `今日，${entity}暂无敏感事件。`;
        if(riskCount){
            setRiskContent = `今日，${entity}共发生敏感事件<b>${total}件</b>。`;
            setRiskContent += this.getRiskLabelStr(yinbaoRiskCounts, riskCategoryCountList)
        }
        return setRiskContent;
    },
    //获取高风险或者高影响力数量
    getHighRiskOrEffectCount(list, range = [1, 2], key = "level", value = "count") {
        if (!list.length)
            return 0;
        return _.chain(list)
            .filter(r => {
                return ~range.indexOf(r[key])
            })
            .sumBy(value).value();
    },

    convertEntityName(name , type = "industry") {
        if(type !== "industry"){
            return name;
        }
        if (~["金融业", "金融", "全行业"].indexOf(name)) {
            name = '金融业';
        } else if (name == "其他") {
            name = `其他金融业`;
        } else if (name !== "其他") {
            name += '业';
        }
        return name;
    },
    convertEntityNameStr(name , type = "industry") {
        if(type !== "industry"){
            return name;
        }
        if (~["金融业", "金融", "全行业"].indexOf(name)) {
            name = '金融业';
        } else if (name == "其他") {
            name = `其他金融业（包含：资产管理、消费金融、金融租赁等）`;
        } else if (name !== "其他") {
            name += '业';
        }
        return name;
    },
    removeToken(key = "xinhuaToken") {
        if (process.env.NODE_ENV === 'local') {
            vueCookie.remove(key);
            return;
        }
        vueCookie.remove(key, null, ".focuxy.com")
    },
    getMainChief(target, path){
        let arr = _.get(target, path, []);
        if(!arr.length)
            return null;

        return  _.orderBy(arr, ["forwardCount"], ["desc"])[0]
    },
    iwomLabel(score, firstNegativeIwom){
        if(score >= 0.9){
            return firstNegativeIwom ? "良好": "优秀"
        }else if(score >= 0.8 && score < 0.9 ){
            return "良好"
        } else{
            return "一般";
        }
    },
    iwomChannelBgColor(score){
       if(score > 0.95 ){
           return "#eaedfa"
       } else if(score > 0.9 && score <= 0.95){
           return "#caddfd"
       } else if(score > 0.85 && score <= 0.9){
           return "#9cc2fc"
       } else if(score > 0.8 && score <= 0.85){
           return "#7da2fa"
       } else if(score > 0.7 && score <= 0.8){
           return "#0962fa"
       } else {
           return "#f2ecea"
       }
    },
    setLocalStorage(key, obj){
        localStorage.setItem(key, JSON.stringify(obj));
    },
    delHtmlTag(str){
        if (!str)
            return "";
        return str.replace(/<[^>]+>/g, "").replace(/&nbsp;/ig, '');
    },
    ContentStrCovertArray(str, splitCharacter="。"){ //根据 splitCharacter 符号， 将字符串转换成数组
        if (!str)
            return [];
        return this.delHtmlTag(str).split(splitCharacter);
    },
    dateStrRange(start, end, delimiter = "-", formatUnit="YYYY年MM月DD日"){
        let startStr = moment(start).format(formatUnit);
        let endStr = moment(end).format(formatUnit);
        if(startStr == endStr){
            return endStr;
        }
        return `${startStr}${delimiter}${endStr}`
    },
    formatNumberWan (n) {
        if(n > 10000)
            return Math.round(n / 10000) + '万'

        return n;
    },
    avgHealth(list, key = "value"){
        let sum = _.sumBy(list, key);
        return Math.ceil(sum/list.length)
    },
    covertHtmlLink(obj){
        return `<a href=${obj.uri ? obj.uri : 'javascript:;'} class="co_333" target=${obj.uri ? "_blank" : ""}>《<b>${obj.title}</b>》</a>`;
    },
    formmatArticleCountByAffect(r) {
        let list = _.chain(r)
            .groupBy("affectLevel")
            .map((items, key) => {
                return {key: Number(key), value: _.sumBy(items, "value")}
            }).value()
        return list;
    }
}
